(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gift-packaging"] && !Shopify.designMode) return;
  try {
    (() => {

  const WIDGET_SELECTOR = '[data-rv-gift-packaging]';

  const CHECKBOX_SELECTOR = '[data-rv-gift-checkbox]';

  const OPTIONS_SELECTOR = '[data-rv-gift-options]';

  const TRIGGER_SELECTOR = '[data-rv-gift-trigger]';

  const MENU_SELECTOR = '[data-rv-gift-menu]';

  const OPTION_SELECTOR = '[data-rv-gift-option]';



  const getProductFormComponent = (widget) => {

    const section = widget.closest('.shopify-section');

    const productId = widget.dataset.productId;

    if (!section || !productId) return null;



    return section.querySelector(

      'product-form-component[data-product-id="' + CSS.escape(productId) + '"]'

    );

  };



  const getForm = (widget) =>

    getProductFormComponent(widget)?.querySelector('form[data-type="add-to-cart-form"]') || null;



  const getQuantity = (form) => {

    const value = Number(form?.querySelector('input[name="quantity"]')?.value);

    return Number.isFinite(value) && value > 0 ? Math.floor(value) : 1;

  };



  const getMainVariantId = (form) => {

    const value = form?.querySelector('input[name="id"]')?.value;

    return value ? String(value) : '';

  };



  const getOptions = (widget) =>

    Array.from(widget.querySelectorAll(OPTION_SELECTOR));



  const getSelectableOptions = (widget) =>

    getOptions(widget).filter((option) => !option.disabled);



  const getSelectedOption = (widget) => {

    const variantId = widget.dataset.selectedPackagingVariantId;

    if (!variantId) return null;

    return widget.querySelector(

      OPTION_SELECTOR + '[data-variant-id="' + CSS.escape(String(variantId)) + '"]'

    );

  };



  const setTriggerImage = (widget, imageUrl, alt) => {

    const imageWrap = widget.querySelector('[data-rv-gift-trigger-image]');

    if (!imageWrap) return;



    imageWrap.replaceChildren();



    if (!imageUrl) return;



    const image = document.createElement('img');

    image.src = imageUrl;

    image.alt = alt || '';

    image.loading = 'lazy';

    imageWrap.appendChild(image);

  };



  const updateSelectedVisuals = (widget) => {

    const selected = getSelectedOption(widget);

    const title = widget.querySelector('[data-rv-gift-title]');

    const price = widget.querySelector('[data-rv-gift-price]');

    const compare = widget.querySelector('[data-rv-gift-compare]');

    const mainImageWrap = widget.querySelector('[data-rv-gift-image-wrap]');

    const triggerTitle = widget.querySelector('[data-rv-gift-trigger-title]');

    const triggerPrice = widget.querySelector('[data-rv-gift-trigger-price]');



    widget.querySelectorAll(OPTION_SELECTOR).forEach((option) => {

      option.setAttribute(

        'aria-selected',

        selected === option ? 'true' : 'false'

      );

    });



    if (!selected) return;



    const selectedTitle = selected.dataset.title || '';

    const selectedPrice = selected.dataset.price || '';

    const selectedCompare = selected.dataset.compare || '';

    const selectedImage = selected.dataset.image || '';



    if (title) title.textContent = selectedTitle;

    if (price) price.textContent = selectedPrice;



    if (compare) {

      compare.textContent = selectedCompare;

      compare.classList.toggle('is-hidden', !selectedCompare);

    }



    if (mainImageWrap) {

      mainImageWrap.replaceChildren();



      if (selectedImage) {

        const image = document.createElement('img');

        image.className = 'rv-gift-packaging__image';

        image.src = selectedImage;

        image.alt = selectedTitle;

        image.loading = 'lazy';

        mainImageWrap.appendChild(image);

      } else {

        const placeholder = document.createElement('span');

        placeholder.className =

          'rv-gift-packaging__image rv-gift-packaging__image--placeholder';

        mainImageWrap.appendChild(placeholder);

      }

    }



    if (triggerTitle) triggerTitle.textContent = selectedTitle;

    if (triggerPrice) triggerPrice.textContent = selectedPrice;

    setTriggerImage(widget, selectedImage, selectedTitle);

  };



  const selectPackaging = (widget, option) => {

    if (!option || option.disabled) return;



    widget.dataset.selectedPackagingVariantId = option.dataset.variantId || '';

    updateSelectedVisuals(widget);

    closePicker(widget);

    syncAll();

  };



  const openPicker = (widget) => {

    const trigger = widget.querySelector(TRIGGER_SELECTOR);

    const menu = widget.querySelector(MENU_SELECTOR);

    if (!trigger || !menu || getOptions(widget).length <= 1) return;



    document.querySelectorAll(WIDGET_SELECTOR + ' [data-rv-gift-menu]:not([hidden])').forEach((openMenu) => {

      if (openMenu !== menu) {

        openMenu.hidden = true;

        openMenu.closest('[data-rv-gift-picker]')?.querySelector(TRIGGER_SELECTOR)?.setAttribute('aria-expanded', 'false');

      }

    });



    menu.hidden = false;

    trigger.setAttribute('aria-expanded', 'true');



    const selected = getSelectedOption(widget);

    selected?.focus({ preventScroll: true });

  };



  const closePicker = (widget) => {

    const trigger = widget.querySelector(TRIGGER_SELECTOR);

    const menu = widget.querySelector(MENU_SELECTOR);

    if (!trigger || !menu) return;



    menu.hidden = true;

    trigger.setAttribute('aria-expanded', 'false');

  };



  const togglePicker = (widget) => {

    const menu = widget.querySelector(MENU_SELECTOR);

    if (!menu || getOptions(widget).length <= 1) return;



    if (menu.hidden) openPicker(widget);

    else closePicker(widget);

  };



  const syncWidget = (widget) => {

    const checkbox = widget.querySelector(CHECKBOX_SELECTOR);

    if (!checkbox) return;



    const options = getOptions(widget);
    const selectableOptions = getSelectableOptions(widget);

    const current = getSelectedOption(widget);

    if (checkbox.checked) {

      if (!current) {

        if (selectableOptions.length) {
          widget.dataset.selectedPackagingVariantId = selectableOptions[0].dataset.variantId || '';
        } else if (widget.dataset.defaultPackagingVariantId) {
          widget.dataset.selectedPackagingVariantId = widget.dataset.defaultPackagingVariantId;
        }

      }

      widget.querySelector('[data-rv-gift-card]')?.classList.add('is-selected');

      updateSelectedVisuals(widget);



      if (getOptions(widget).length <= 1) {

        closePicker(widget);

      }

    } else {

      widget.querySelector('[data-rv-gift-card]')?.classList.remove('is-selected');

      closePicker(widget);

    }

  };



  const syncForm = (form, widgets) => {

    if (!form || widgets.length === 0) return;



    const productForm = form.closest('product-form-component');

    if (!productForm) return;



    const mainVariantId = getMainVariantId(form);

    if (!mainVariantId) {

      productForm.dataset.revoshaGiftItems = '[]';

      form.querySelectorAll('[data-rv-gift-additional]').forEach((input) => input.remove());

      return;

    }



    const selectedItems = [];



    widgets.forEach((widget) => {

      const checkbox = widget.querySelector(CHECKBOX_SELECTOR);

      if (!checkbox?.checked) return;



      const variantId = widget.dataset.selectedPackagingVariantId;

      if (!variantId || String(variantId) === mainVariantId) return;



      const quantityMode = widget.dataset.quantityMode || 'match_product';



      selectedItems.push({

        variantId: String(variantId),

        quantity: quantityMode === 'one' ? 1 : getQuantity(form),

      });

    });



    const dedupedItems = [];

    const seen = new Set();



    selectedItems.forEach((item) => {

      if (seen.has(item.variantId)) return;

      seen.add(item.variantId);

      dedupedItems.push(item);

    });



    productForm.dataset.revoshaGiftItems = JSON.stringify(dedupedItems);



    form.querySelectorAll('[data-rv-gift-additional]').forEach((input) => input.remove());



    dedupedItems.forEach((item, index) => {

      const addHidden = (name, value) => {

        const input = document.createElement('input');

        input.type = 'hidden';

        input.name = name;

        input.value = String(value);

        input.dataset.rvGiftAdditional = 'true';

        form.appendChild(input);

      };



      const position = index + 1;



      addHidden(

        'shopify-additional-items[' + position + '][id]',

        item.variantId

      );

      addHidden(

        'shopify-additional-items[' + position + '][parent_id]',

        mainVariantId

      );

      addHidden(

        'shopify-additional-items[' + position + '][quantity]',

        item.quantity

      );

    });

  };



  const syncAll = () => {

    const widgets = Array.from(document.querySelectorAll(WIDGET_SELECTOR));

    const forms = new Set();



    widgets.forEach((widget) => {

      const form = getForm(widget);

      if (form) forms.add(form);

      syncWidget(widget);

    });



    forms.forEach((form) => {

      const section = form.closest('.shopify-section');

      const productForm = form.closest('product-form-component');

      if (!section || !productForm) return;



      const widgetsForForm = Array.from(

        section.querySelectorAll(WIDGET_SELECTOR)

      ).filter(

        (widget) =>

          widget.dataset.productId === productForm.dataset.productId

      );



      syncForm(form, widgetsForForm);

    });

  };



  let scheduled = false;



  const scheduleSync = () => {

    if (scheduled) return;

    scheduled = true;



    requestAnimationFrame(() => {

      scheduled = false;

      syncAll();

    });

  };



  document.addEventListener('change', (event) => {

    const target = event.target;



    if (

      target instanceof HTMLInputElement &&

      target.matches(CHECKBOX_SELECTOR)

    ) {

      const widget = target.closest(WIDGET_SELECTOR);

      if (!widget) return;

      syncAll();

    }



    if (

      target instanceof HTMLInputElement &&

      target.name === 'quantity'

    ) {

      syncAll();

    }

  });



  document.addEventListener('input', (event) => {

    if (

      event.target instanceof HTMLInputElement &&

      event.target.name === 'quantity'

    ) {

      syncAll();

    }

  });



  document.addEventListener('pointerdown', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const trigger = target.closest(TRIGGER_SELECTOR);
    const option = target.closest(OPTION_SELECTOR);

    // Keep the picker interaction inside this component. In particular, do not
    // let another document-level pointer handler treat the trigger click as an
    // outside click and close the menu immediately after it opens.
    if (trigger) {
      const widget = trigger.closest(WIDGET_SELECTOR);
      if (!widget) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      trigger.dataset.rvGiftPointerHandled = 'true';
      togglePicker(widget);
      return;
    }

    if (option) {
      event.stopImmediatePropagation();
    }
  }, true);



  document.addEventListener('click', (event) => {

    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const option = target.closest(OPTION_SELECTOR);

    if (option) {
      const widget = option.closest(WIDGET_SELECTOR);
      if (widget) {
        event.preventDefault();
        event.stopImmediatePropagation();
        selectPackaging(widget, option);
      }
      return;
    }

    const trigger = target.closest(TRIGGER_SELECTOR);

    if (trigger) {
      // The pointerdown handler already opened/closed the picker. Do not toggle
      // it a second time during the synthetic mouse click that follows.
      if (trigger.dataset.rvGiftPointerHandled === 'true') {
        delete trigger.dataset.rvGiftPointerHandled;
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const widget = trigger.closest(WIDGET_SELECTOR);
      if (widget) {
        event.preventDefault();
        event.stopImmediatePropagation();
        togglePicker(widget);
      }
      return;
    }

    if (!target.closest('[data-rv-gift-picker]')) {
      document
        .querySelectorAll(WIDGET_SELECTOR + ' [data-rv-gift-menu]:not([hidden])')
        .forEach((menu) => {
          const widget = menu.closest(WIDGET_SELECTOR);
          if (widget) closePicker(widget);
        });
    }

  }, true);



  document.addEventListener('keydown', (event) => {

    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const trigger = target.closest(TRIGGER_SELECTOR);

    const option = target.closest(OPTION_SELECTOR);



    if (event.key === 'Escape') {

      const widget = (trigger || option)?.closest(WIDGET_SELECTOR);

      if (widget) {

        closePicker(widget);

        widget.querySelector(TRIGGER_SELECTOR)?.focus();

      }

      return;

    }



    if (trigger && (event.key === 'Enter' || event.key === ' ')) {

      event.preventDefault();

      const widget = trigger.closest(WIDGET_SELECTOR);

      if (widget) togglePicker(widget);

      return;

    }



    if (option && (event.key === 'Enter' || event.key === ' ')) {

      event.preventDefault();

      const widget = option.closest(WIDGET_SELECTOR);

      if (widget) selectPackaging(widget, option);

    }

  }, true);



  document.addEventListener('shopify:product:select', syncAll);

  document.addEventListener('submit', (event) => {
  const form = event.target instanceof HTMLFormElement
    ? event.target
    : null;

  if (!form?.matches('form[data-type="add-to-cart-form"]')) return;

  const productForm = form.closest('product-form-component');
  if (!productForm) return;

  const widgets = Array.from(
    form.closest('.shopify-section')?.querySelectorAll(WIDGET_SELECTOR) || []
  ).filter(
    (widget) => widget.dataset.productId === productForm.dataset.productId
  );

    syncForm(form, widgets);
  }, true);

  document.addEventListener('shopify:section:load', scheduleSync);

  document.addEventListener('shopify:section:unload', scheduleSync);

  document.addEventListener('shopify:block:select', scheduleSync);

  document.addEventListener('shopify:block:deselect', scheduleSync);



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });

  } else {

    scheduleSync();

  }

})();
  } catch(e) { console.error(e); }
})();

})();
